import {AccountSuspensionAPI} from "../apis/AccountSuspensionAPI.js";

/**
 * Created by Mohamed on 4/20/2016.
 */
angular.module("harriMainApp").config(["$provide", "$filterProvider", '$compileProvider', function ($provide, $filterProvider, $compileProvider) {

    window.$filterProvider = $filterProvider;

    // Disable debugging mode in case of production
    CDNUri && $compileProvider.debugInfoEnabled(false);

    $provide.decorator("$exceptionHandler", ['$delegate', function ($delegate) {
        return function (exception, cause) {
            let ignoreReporting = false;
            let stopDelegation = false;

            let errorMsg = typeof exception === 'string'? exception: exception?.message;

            if (errorMsg?.includes('The transition has been superseded by a different transition')) {
                ignoreReporting = true;
                stopDelegation = true;
            }
            else if (errorMsg?.includes('NG0909')) {
                ignoreReporting = true;
            }

            if (window && window.DD_RUM) {
                window.DD_RUM.onReady(function () {
                    if (!ignoreReporting) {
                        window.DD_RUM.addError(exception);
                    }
                });
            }

            if (!stopDelegation) {
                $delegate(exception, cause);
            }
        };
    }]);

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|microsoft-edge):/);

    //IE9-only fix to handle CORS requests
    if($('html').is('.lt-ie10')) {

        $.getScript(CDNUri+'ext_libs/xdomain/dist/0.6/xdomain.min.js', function() {
            var xdomainSlaves = {};

            var serverAPI = publicConfiguration.APIServerBaseURL;

            //get the base backend domain.
            var searchToken = ".com";
            serverAPI = serverAPI.substr(0,serverAPI.indexOf(searchToken) + searchToken.length);

            xdomainSlaves[serverAPI] = "/proxy.html";
            xdomain.slaves(xdomainSlaves);

        });

    }

}]).run(["$rootScope",'deviceChecker', 'hUser', 'initSmartTag','localize', 'httpHelper', '$state', '$injector', '$modal', 'versionManager',
    function ($rootScope, deviceChecker, hUser, initSmartTag, localize, httpHelper, $location, $injector, $modal, versionManager) {
        window.$injector = $injector;
        window._bsModal = $modal;
        localize.init();

        var location = window.location.pathname || "";
        var queryParams = window.location.search || "";
        var noPromoLocations = ["light-signup", "offer/", "documents/"];
        var noPromotion = false;

        hLoginManager.isLoggedIn().then(function (isLoggedIn) {
            if (isLoggedIn) {
                hUser.init()
                    .then(() => {
                        if(hUser.isEmployer()){
                            versionManager.init(hUser.getEntryMode().brand_id);
                        }
                        $('body').addClass(hUser.isEmployer() ? 'employer-body' : 'employee-body');
                    })
                    .catch((err) => console.error(err));
            } else {
                $('body').addClass('employee-body');
            }
        });

        for (var i in noPromoLocations) {
            if (location.indexOf(noPromoLocations[i]) > -1) {
                noPromotion = true;
            }
        }

        if (queryParams.indexOf("noPromo") > -1 || hUser.isPrivacyShieldOn()) {
            noPromotion = true;
        }

        if (noPromotion) {
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                key: 'nopromo',
                value: true,
                expiryDays: 2
            });
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                key: 'candidateAppMobileWelcome',
                value: true,
                expiryDays: 2
            });
        }

    }
]).run(['hUser', '$urlRouter', '$rootScope', '$filter', 'localize', '$state', 'platformNavigatorService', function (hUser, $urlRouter, $rootScope, $filter, localize, $state, platformNavigatorService) {


    var currentLang = localize.getLang();

    if (currentLang != 'en' && typeof lookups_lang != "undefined") {

        for (var key in lookups_lang) {

            if (!lang[key]) {
                lang[key] = lookups_lang[key];
            }
        }
    }

    localize.loadLocaleScript(currentLang);

    /* Change Language for moment.js globaly
     ===========================================
     */
    moment.locale(localize.getLocaleCode());


    var _alertDisplayed = false;
    let loginToken;

    hLoginManager.getToken()
        .then((token) => {
            loginToken = token;
        });
    var onWindowFocusHandler = async function(wasLoggedIn){
        if (hUser.isLoggedIn()) {//check if user logged in and need to setup mfa
            const [token, isImpersonating] = await Promise.all(
                [
                    hLoginManager.getToken(),
                    hLoginManager.isImpersonating()
                ]
            );

            if (!_alertDisplayed && isImpersonating && loginToken && loginToken !== token) {
                hUser.reset();
                const redirectToHomePage = () => {
                    window.location.href = '/dashboard';
                };

                hAlert({
                    title: $filter("translate")('Session paused'),
                    text: $filter("translate")("This session is paused because you switched to another account. Select Ok and the page will refresh to launch your active account."),
                    onHide: redirectToHomePage,
                    button: {
                        on_confirm: redirectToHomePage,
                        text: $filter("translate")('Ok')
                    }
                });
                _alertDisplayed = true;
                return;
            }

            hUser.getUserMfaStatus()
                .then(function (userMfaStatus) {
                    if (userMfaStatus.mfa_setup_required && $state.$current.name !== 'registration.setupMfa') {
                        hRedirect('/user/setup-mfa');
                    } else if ($state.$current.name === "registration.login" && hLoginManager.canRedirectIfLoggedIn()) {
                        // already logged in
                        hRedirect('/dashboard');
                    } else if (hLoginManager.canRedirectIfLoggedIn()) {
                        // update user info
                        hUser.refresh()
                            .finally(() => {
                                if (hUser.isEmployer()) {
                                    const toStateName = $state?.transition?.to()?.name || $state?.current?.name;
                                    platformNavigatorService.handleLogInAccessRedirection(toStateName);
                                }
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    }
                });
        }
        else if(wasLoggedIn && !_alertDisplayed) {
            // session timeout
            _alertDisplayed = true;
            hUser.logout().then(function(){
                hAlert($filter("translate")("Please login"), 'Your session has timed out, please login.',function(){
                    hRedirect('/user/login');
                });
            });

        }
    };

    //update user session after changing browser tabs
    $(window).focus(function(e) {
        onWindowFocusHandler(hUser.isLoggedIn());
    });

}])
    .run([
        "$rootScope", "$transitions", "$q", "$urlRouter", "asyncGlobalHandler", "$state", "$location", "hEvent", "hUser", "SharedBrand", "$timeout", "$anchorScroll", "localize", "DispatcherServices", "JobDetailsBus", "userPermissions", "hTransitions", "krtMarketingTrackingService", "$modal", "announcementsService", "brandServices", "barriAnalyticsService", "googleTagManagerTrackingService", "BrandProfileDataBus", "CareerPortalDataBus", "initSmartTag", "platformNavigatorService",
        function ($rootScope, $transitions, $q, $urlRouter, asyncGlobalHandler, $state, $location, hEvent, hUser, SharedBrand, $timeout, $anchorScroll, localize, DispatcherServices, JobDetailsBus, userPermissions, hTransitions, krtMarketingTrackingService, $modal, announcementsService, brandServices, barriAnalyticsService, googleTagManagerTrackingService, BrandProfileDataBus, CareerPortalDataBus, initSmartTag, platformNavigatorService) {
        let contextData;
    //watch page changes
        hTransitions.init();

        hTransitions.onStart({ }, async function (trans) {
            var defer = $q.defer();

            var fromState = trans.from();
            var toState = trans.to();
            var fromParams = trans.params('from');
            var toParams = trans.params('to');
            
            $("body").removeClass("lang-" + localize.getLang());
            localize.disabled = localize.isRouteDisabled(toState.name);
            $("body").addClass("lang-" + localize.getLang());

            if (!localize.localeDisabled) {
                if (localize.isRTL()) {
                    $("body").addClass("rtl");
                } else {
                    $("body").removeClass("rtl");
                }
            }

            if (toParams && toParams.clear_context) {
                hUser.clearUserContext();
            }

            if (fromState.name != toState.name) {
                if (toState.name !== "registration.setupMfa") {
                    if (hUser.isLoggedIn()) {
                        hUser.getUserMfaStatus().then(function (userMfaStatus) {
                            if (userMfaStatus.mfa_setup_required) {
                                hRedirect('/user/setup-mfa');
                            }
                        });
                    }
                }

                await hUser.redirectToPlatformWithPermission();
                if (hUser.isEmployer()) {
                    await platformNavigatorService.handleLogInAccessRedirection(toState.name);
                }
            }

            //try to set user context
            if (toParams && !isNaN(parseInt(toParams.gid))) {
                var groupId = parseInt(toParams.gid);

                hUser.setUserContext({brand_id: groupId, brand_type: "enterprise"})
                    .catch(function (err) {
                        console.error(err);
                    });
            }

            // On change start, kick the start for performance utils to set the start change time
            PerformanceUtils.startTracking(toState);

            closeOffCanvas();

            asyncGlobalHandler.watchPageChange();

            /**
             * Put Referal and toState inside rootScope
             */
            $rootScope.referal = {
                state : fromState,
                params : fromParams
            };

            $rootScope.toState = {
                state : toState,
                parms : toParams
            };

            // Log the previous state only if the user  not enter some screens
            // @TODO rename returnToOnLogin
            if (toState.returnToOnLogin !== true ) {
                $rootScope.$previousState = toState.name;
                $rootScope.$previousStateParam = toParams;
                $rootScope.$previousIsDynamic = toState.hasOwnProperty('dynamic-template');

                $timeout(function(){
                    $rootScope.$previousLocationURL = hGetCurrentUrl();
                }, 500); // used for coz sometimes its take some delay when changing url
            }

            // if he logged out clear the states to force it to return to dashboard
            if( toState.clearPrevState ) {
                $rootScope.$previousState = null;
                $rootScope.$previousStateParam = null;
                $rootScope.$previousIsDynamic = null;
                $rootScope.$previousLocationURL = null;

                $rootScope.referal = null;
            }

            function checkCandidatePrivacy() {
                var defer = $q.defer();

                var brandId = getBrandId();
                brandServices.check(brandServices.SERVICES.CANDIDATE_PRIVACY, brandId, true)
                    .then(function (hide_images) {
                        MediaUtils.setCurrentUserId(hUser.getUser().id);
                        MediaUtils.hideUserProfileImages(hide_images);
                    })
                    .finally(function () {
                        defer.resolve();
                    });

                return defer.promise;
            }

            function getBrandId() {
                var brandId;

                if (toState.name.indexOf("appLayout.harriSH.access-portal") > -1) {
                    brandId = hUser.getUser().entry_mode.brand_id;
                } else if (!hUser.isTopLevelContext() && hUser.getUser().brands_list && hUser.getUser().brands_list.length === 1) {
                    brandId = hUser.getUser().brands_list[0].id;
                } else {
                    brandId = hUser.getUserContext().brand_id;
                }
                return brandId;
            }

            var checkBrandRumSettings = function () {
                var brandId = getBrandId();

                UserTrackingManagerAPI.getBrandRumSettings(brandId)
                    .then(function (brandRumSettings) {
                        if (brandRumSettings.is_enabled && brandRumSettings.sampling_percentage > 0) {
                            var config = EnvironmentsConfig.get('DataDogConfig');
                            var host = EnvironmentsConfig.getEnv().host;

                            window.DD_RUM.init({
                                applicationId: config.applicationId,
                                clientToken: config.clientToken,
                                site: 'datadoghq.com',
                                service: 'FE',
                                version: typeof buildVersion !== "undefined" ? `FE-${buildVersion}` : '',
                                sessionSampleRate: brandRumSettings.sampling_percentage,
                                sessionReplaySampleRate: brandRumSettings.session_recording_percentage || brandRumSettings.sampling_percentage,
                                defaultPrivacyLevel: 'mask-user-input',
                                actionNameAttribute: 'data-custom-name',
                                env: host,
                                trackResources: true,
                                trackLongTasks: true,
                                trackUserInteractions: true,
                                trackFrustrations: true,
                                allowedTracingUrls: [function (url) {
                                    return url.startsWith("https://gateway.harri");
                                }]
                            });

                            window.DD_LOGS.init({
                                service: 'FE',
                                env: host,
                                clientToken: config.clientToken,
                                version: typeof buildVersion !== "undefined" ? `FE-${buildVersion}` : '',
                                site: 'datadoghq.com',
                                forwardErrorsToLogs: true,
                                sessionSampleRate: brandRumSettings.sampling_percentage,
                            });

                            if (hUser.data.user) {
                                var userInfo = {
                                    brand_id: brandId,
                                    email: hUser.data.user.email,
                                    id: hUser.data.user.id,
                                    team_user_id: hUser.data.user.team_user_id,
                                };
                                window.DD_RUM.setUser(userInfo);
                            }
                            window.DD_RUM.startSessionReplayRecording();
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }

            function accountSuspension() {
                var defer = $q.defer();

                AccountSuspensionAPI.checkAccountSuspension(hUser.getEntryMode().brand_id)
                    .then(function (isSuspended) {
                        if (isSuspended) {
                            $state.go('account-suspension');
                            defer.resolve();
                        }
                    })
                    .catch(function (err) {
                        console.log('err', err);
                        defer.resolve();
                    });
                return defer.promise;
            }

            if (toState.analytics_name === 'profile.candidate') {
                var currentUserSlug = hUser.isLoggedIn() && hUser.data.user.slug;

                if (currentUserSlug != toState.slug) {
                    hUser.isFromUK()
                        .then(function (fromEU) {
                            if (fromEU) {
                                Utils.redirectToWorkspace("homepage");
                            }
                            else {
                                defer.resolve();
                            }
                        });
                }
                else {
                    defer.resolve();
                }
            }
            else if (!hUser.isLoggedIn() && toState.loginScreen !== true && (toState.loginRequired || toState.requiredServiceCheck)) {
                hUser.getFullUserData()
                    .then(function () {
                        if (hUser.isLoggedIn()) {
                            if (hUser.isEmployer()) {
                                accountSuspension()
                                    .then(function() {
                                        defer.resolve();
                                })
                                var promises = {};

                                promises['user_policy'] = hUser.getUserPolicy();
                                promises['candidate_privacy'] = checkCandidatePrivacy();
                                $q.all(promises)
                                    .then(function () {
                                        defer.resolve();
                                    });
                                checkBrandRumSettings();
                            } else {
                                defer.resolve();
                            }

                        } else if (toState.loginRequired) {
                            Utils.redirectToWorkspace('registration.login', {'ref': encodeURIComponent(window.location.href)})
                        } else {
                            defer.resolve();
                        }
                    });
            }
            else {
                if (hUser.isEmployer() && (toState.loginRequired || toState.requiredServiceCheck)) {
                    accountSuspension()
                        .then(function() {
                            defer.resolve();
                        });

                    checkCandidatePrivacy()
                        .then(function () {
                            defer.resolve();
                        })
                } else {
                    defer.resolve();
                }
            }

            trans.promise
                .finally(function () {

                    asyncGlobalHandler.watchPageChangeFinished();
                });

            return defer.promise;
        });

            ReferralUtils.parseUTMParams();

    if( getParameterByName('ref', window.location.href) != '' ){
        window.referer = getParameterByName('ref', window.location.href);
    }

        hTransitions.onSuccess({}, function (trans) {

            var fromState = trans.from();
            var toState = trans.to();
            var toParams = trans.params('to');

            if (hUser.isEmployer() && !window.lmsPromoModalShown && ['appLayout.harriSH.dashboard', 'appLayout.harriSH.dashboard-hiring', 'appLayout.harriSH.dashboard-tts', 'appLayout.harriSH.access-portal', 'appLayout.harriSH.access-portal.main'].indexOf(toState.name) > -1) {
                announcementsService.hasAnnouncement(announcementsService.LMS_HARASSMENT)
                    .then(function (showLMSDemo) {
                        if (showLMSDemo) {

                            window.lmsPromoModalShown = true;

                            $modal({
                                controller: 'LmsPromoModal',
                                controllerAs: 'lmsPromoModal',
                                templateUrl: '../hmodules/lms/modals/lms-promo-modal/lms-promo.modal.html',
                                show: true,
                                resolve: {
                                    modalData: function () {
                                        return {
                                            onSuccess: function (requestedDemo) {
                                                if (requestedDemo) {
                                                    hAlert('<i class="fa fa-check-circle-o"></i> ' + $filter("translate")("Thank you!"),
                                                        $filter("translate")("Thank you for your request for a demo of") + " Harassment and Discrimination Prevention Training for the Hospitality Industry (NY Edition). " + $filter("translate")("Our team will be in touch with you shortly."),
                                                        null,
                                                        "schedule-demo-success-alert");
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
            }

        // Some users don't have first_name and last_name, force them to fill these information in the settings
        if ($state.current.name != 'appLayout.harriSH.editprofile'
            && hUser.isLoggedIn()
            && hUser.data
            && hUser.data.user
            && (!hUser.isEmployer() || hUser.isOnboardingServiceEnabled())) {

                var userInfo = hUser.data.user;

                if (!userInfo.first_name || !userInfo.last_name) {
                    hRedirect("edit/profile/basic_information");
                    return;
                }
            }

            if (typeof(dataLayer) != 'undefined') {
                var targetStateName = (toState && toState.name) || '';

                setTimeout(function () {
                    if (
                        targetStateName.indexOf("cotecareers") === -1
                        && targetStateName.indexOf("_employer") === -1
                        && targetStateName.indexOf("_job-post") === -1
                    ) {
                        googleTagManagerTrackingService.destroy();
                        console.warn("Disable Google Tag Manager Data Layer");
                        dataLayer.push({
                            'gtm.blacklist': ['google', 'nonGoogleScripts', 'customScripts', 'customPixels']
                        });
                    }
                }, 500);
            }

            if( getParameterByName('ref', window.location.href) != '' ){
                window.referer = getParameterByName('ref', window.location.href);
            }

            //track page url
            // disable scroll on some situations
            var fromScroll = !!fromState.disableAutoScroll;
            var toScroll = !!toState.disableAutoScroll;
            var dontScroll = (toScroll && !fromScroll) || (toScroll && fromScroll) || (!toScroll && fromScroll );

            if( !dontScroll ) {
                $anchorScroll();
            }
            else {
                // Scroll to old value after changing the URL
                // Avoids browser default behaviour
                var scrollTop = $(window).scrollTop();
                $(document).ready(function() {
                    $timeout(function(){
                        $(window).scrollTop(scrollTop);
                    });
                });
            }

            var userType = hUser.getUserType();

            if (hUser.isSBMLAdmin()) {
                userType = "sbml_admin";
            }
            else if (hUser.isSBMLChild()) {
                userType = "sbml_child";
            }

            if (!hUser.isEmployer()) {

                window.reportingViews = window.reportingViews || {};

                if (toState && (toState.analytics_name === 'JPLP' || (toState.name && toState.name.indexOf('.apply') > -1))) {

                    var jobId = toParams.jobid || toParams.job_id;
                    var brandId = toParams.id;
                    var jobReferrerId = toParams.job_referrer_id;
                    var socialMediaChannel = toParams.social_media_channel;
                    var pjt = toParams.pjt;

                    if (jobId && !window.reportingViews[jobId]) {
                        var srcReferal = ReferralUtils.getRefererSource();
                        srcReferal.referrer = srcReferal.referrer || "";

                        var internalHarriSources = ReferralUtils.getInternalSources();
                        var source = srcReferal.referrer;

                        for (var i in internalHarriSources) {
                            if (internalHarriSources[i] === source) {
                                source = "HARRI";
                                break;
                            }
                        }

                        source = source || 'HARRI';

                        setTimeout(function () {
                            JobDetailsBus.getJob(jobId, pjt)
                                .then(function (job) {
                                    ReportingAPI.trackReportingView(jobId, source, job.brand.id, jobReferrerId, socialMediaChannel);
                                    krtMarketingTrackingService.trackView(jobId, pjt);
                                    googleTagManagerTrackingService.init([job.brand.id, job.brand.group_id, job.top_parent_brand.id]);
                                });
                        }, 1000);


                        window.reportingViews[jobId] = source;
                    }
                }

                if (toState && toState.analytics_name === 'profile.brand') {
                    var brandDetails = BrandProfileDataBus.getData() || CareerPortalDataBus.getBasicInfo();
                    var brandIds = [];
                    brandDetails.id && brandIds.push(brandDetails.id);
                    brandDetails.group_id && brandIds.push(brandDetails.group_id);
                    googleTagManagerTrackingService.init(brandIds);
                }
            }

            var toName = toState.analytics_name || toState.name;
            if (hUser.isLoggedIn()) {
                hEvent.identifyOnPageView(hUser.data.user, toName);
            }
            hEvent.pageView(toName, $location.path(), document.title, userType);
            if (hUser.isEmployer() && hUser.getUserContext() && (!contextData || contextData.locationId !== (hUser.getUserContext().active_brand_id || hUser.getUserContext().brand_id))) {
                contextData = {
                    locationId: (hUser.getUserContext().active_brand_id || hUser.getUserContext().brand_id).toString(),
                    locationName: hUser.getUserContext().brand_name || '',
                    brandType: hUser.getUserContext().active_brand_type || hUser.getUserContext().brand_type
                }
                hEvent.setGlobalContext(contextData);
            }

            asyncGlobalHandler.watchPageChangeFinished();

            // If page is not handling its time tracking in a custom way, trigger the event after some delay
            if (!toState.preventTimeTracking) {
                setTimeout(function(){
                    PerformanceUtils.trackLoaded(hUser, toState, $location.path());
                }, 150);
            }

            var hideIeModal = HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.SESSION,
                key: 'hideIEWarningModal'
            });

            if (deviceChecker.isIE() && !hideIeModal) {
                hEvent.track("ie_modal_open", { category: 'ie_deprecation', label: hUser.data.user.id });
                $modal({
                    controller: 'ieDeprecationWarningModal',
                    controllerAs: '$ctrl',
                    templateUrl: '../modules/ie11page/views/ie11.html',
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {};
                        }
                    }
                });
            }

            $timeout(function(){
                var showMobilePromo = deviceChecker.isMobile() && !HStorageManager.get({storageLevel: HStorageManager.StorageLevels.COOKIES, key: 'candidateAppMobileWelcome'}) && DispatcherServices.getConfig().isMobielPromotionEnabled();
                // show app promotion in case user not on reg
                if ($.inArray(toState.url, ['/apply/:job_id']) == -1
                    && hUser.isLoggedIn()
                    && !hUser.isEmployer()
                    && showMobilePromo
                    && $('.mobile-cover:visible').length == 0) {
                    // TODO: Fix this line (removed temporarily)
                    // HARRI-11714: User cannot use site on iOS, endless refresh
                    // hRedirect(window.location.href);
                }
            });
            initSmartTag.checkIfCanShowMobileBanner(false, fromState, toState);
        });


    $rootScope.$on('$locationChangeStart', function(evt, absNewUrl, absOldUrl){

        closeOffCanvas();

        if (  absNewUrl.toLowerCase().indexOf('subscription') != -1 || absNewUrl.toLowerCase().indexOf('subscriptionbrand') != -1 ){
            var checkout      =   absOldUrl.toLowerCase().indexOf('appLayout.harriSH.checkout') == -1;
            var pricing  =   absOldUrl.toLowerCase().indexOf('pricing') == -1;
            /*
             *   ! ( XOR Logical Operator )
             */
            if( !( ( checkout || pricing ) && !( checkout && pricing ) ) ){
                SharedBrand.url = absOldUrl;
            }
        }


    });


}]);
